import * as React from 'react';
import ListItemText from '@material-ui/core/ListItemText';

const CustomListItemText = (props) => {
    return <ListItemText {...props} />;
};

export { CustomListItemText as ListItemText };
